/**
 * @generated SignedSource<<5963d4eb760dccc2f26194a4f6931477>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TrackViewEvent = "DIRECT" | "INDIRECT" | "SKIP";
export type ProjectViewAsideQuery$variables = {
  areMilestonesEnabled: boolean;
  cloudId?: string | null;
  isProjectNativeIntegrationEnabled: boolean;
  key: string;
  trackViewEvent?: TrackViewEvent | null;
  workspaceId?: string | null;
};
export type ProjectViewAsideQuery$data = {
  readonly currentUser: {
    readonly aaid: string | null;
  } | null;
  readonly project: {
    readonly ari: string;
    readonly members: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly owner: {
      readonly aaid: string | null;
    } | null;
    readonly private: boolean;
    readonly watchers: {
      readonly " $fragmentSpreads": FragmentRefs<"utils_isUserInList">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"ProjectSidebar">;
  } | null;
};
export type ProjectViewAsideQuery = {
  response: ProjectViewAsideQuery$data;
  variables: ProjectViewAsideQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areMilestonesEnabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isProjectNativeIntegrationEnabled"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "key"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trackViewEvent"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workspaceId"
},
v6 = {
  "kind": "Variable",
  "name": "key",
  "variableName": "key"
},
v7 = [
  (v6/*: any*/),
  {
    "kind": "Variable",
    "name": "trackViewEvent",
    "variableName": "trackViewEvent"
  }
],
v8 = {
  "kind": "ScalarField",
  "name": "ari"
},
v9 = {
  "kind": "ScalarField",
  "name": "aaid"
},
v10 = [
  (v9/*: any*/)
],
v11 = {
  "kind": "ScalarField",
  "name": "private"
},
v12 = [
  {
    "kind": "InlineDataFragmentSpread",
    "name": "utils_isUserInList",
    "selections": [
      {
        "concreteType": "UserEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": (v10/*: any*/)
          }
        ]
      }
    ],
    "argumentDefinitions": ([]/*: any*/)
  }
],
v13 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v14 = [
  {
    "kind": "Variable",
    "name": "workspaceId",
    "variableName": "workspaceId"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "id"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "picture"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v19 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v20 = [
  (v9/*: any*/),
  (v15/*: any*/)
],
v21 = {
  "kind": "ScalarField",
  "name": "count"
},
v22 = {
  "kind": "ScalarField",
  "name": "key"
},
v23 = {
  "kind": "ScalarField",
  "name": "value"
},
v24 = {
  "kind": "ScalarField",
  "name": "targetDate"
},
v25 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v26 = {
  "kind": "ScalarField",
  "name": "watching"
},
v27 = {
  "kind": "ScalarField",
  "name": "archived"
},
v28 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v29 = {
  "concreteType": "UserPII",
  "kind": "LinkedField",
  "name": "pii",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v16/*: any*/),
    (v18/*: any*/),
    (v19/*: any*/),
    {
      "concreteType": "ExtendedProfile",
      "kind": "LinkedField",
      "name": "extendedProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "jobTitle"
        }
      ]
    }
  ]
},
v30 = [
  (v9/*: any*/),
  (v29/*: any*/),
  (v15/*: any*/)
],
v31 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": "connectionId",
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v32 = [
  (v15/*: any*/)
],
v33 = {
  "kind": "InlineFragment",
  "selections": (v32/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v34 = {
  "kind": "ScalarField",
  "name": "type"
},
v35 = [
  (v21/*: any*/)
],
v36 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "alias": "connId",
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v37 = {
  "kind": "ScalarField",
  "name": "label"
},
v38 = {
  "concreteType": "LocalizationField",
  "kind": "LinkedField",
  "name": "localizedLabel",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    }
  ]
},
v39 = {
  "kind": "ScalarField",
  "name": "url"
},
v40 = {
  "kind": "ScalarField",
  "name": "description"
},
v41 = {
  "kind": "LinkedField",
  "name": "definition",
  "plural": false,
  "selections": [
    (v28/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v16/*: any*/),
        (v40/*: any*/)
      ],
      "type": "CustomFieldDefinitionNode",
      "abstractKey": "__isCustomFieldDefinitionNode"
    },
    (v33/*: any*/)
  ]
},
v42 = {
  "kind": "InlineFragment",
  "selections": [
    (v34/*: any*/)
  ],
  "type": "CustomFieldDefinitionNode",
  "abstractKey": "__isCustomFieldDefinitionNode"
},
v43 = {
  "kind": "ScalarField",
  "name": "canSetMultipleValues"
},
v44 = [
  (v43/*: any*/)
],
v45 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "UserCustomFieldDefinition"
},
v46 = {
  "kind": "InlineFragment",
  "selections": (v44/*: any*/),
  "type": "TextSelectCustomFieldDefinition"
},
v47 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "definition",
      "plural": false,
      "selections": [
        (v42/*: any*/),
        (v45/*: any*/),
        (v46/*: any*/)
      ]
    }
  ],
  "type": "CustomFieldNode",
  "abstractKey": "__isCustomFieldNode"
},
v48 = [
  (v15/*: any*/),
  (v23/*: any*/)
],
v49 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v50 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ProjectViewAsideQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v7/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": (v10/*: any*/)
          },
          (v11/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "areMilestonesEnabled",
                "variableName": "areMilestonesEnabled"
              },
              (v13/*: any*/),
              {
                "kind": "Variable",
                "name": "isProjectNativeIntegrationEnabled",
                "variableName": "isProjectNativeIntegrationEnabled"
              },
              (v6/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "ProjectSidebar"
          }
        ]
      },
      {
        "args": (v14/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": (v10/*: any*/)
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "ProjectViewAsideQuery",
    "selections": [
      {
        "alias": "project",
        "args": (v7/*: any*/),
        "concreteType": "Project",
        "kind": "LinkedField",
        "name": "projectByKey",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "owner",
            "plural": false,
            "selections": [
              (v9/*: any*/),
              (v15/*: any*/),
              {
                "concreteType": "UserPII",
                "kind": "LinkedField",
                "name": "pii",
                "plural": false,
                "selections": [
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "email"
                  },
                  (v19/*: any*/)
                ]
              }
            ]
          },
          (v11/*: any*/),
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "members",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v20/*: any*/)
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          {
            "concreteType": "UserConnection",
            "kind": "LinkedField",
            "name": "watchers",
            "plural": false,
            "selections": [
              {
                "concreteType": "UserEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      (v15/*: any*/),
                      {
                        "concreteType": "UserPII",
                        "kind": "LinkedField",
                        "name": "pii",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v19/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v21/*: any*/)
            ]
          },
          (v15/*: any*/),
          (v22/*: any*/),
          {
            "concreteType": "ProjectState",
            "kind": "LinkedField",
            "name": "state",
            "plural": false,
            "selections": [
              (v23/*: any*/),
              {
                "concreteType": "CompletionProjectState",
                "kind": "LinkedField",
                "name": "atCompletionState",
                "plural": false,
                "selections": [
                  (v23/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "creationDate"
          },
          {
            "kind": "ScalarField",
            "name": "startDate"
          },
          (v24/*: any*/),
          {
            "kind": "ScalarField",
            "name": "targetDateConfidence"
          },
          (v25/*: any*/),
          (v26/*: any*/),
          {
            "concreteType": "TownsquareProjectCapabilities",
            "kind": "LinkedField",
            "name": "capabilities",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canWatchProject"
              },
              {
                "kind": "ScalarField",
                "name": "canArchiveProject"
              }
            ]
          },
          (v16/*: any*/),
          (v27/*: any*/),
          {
            "kind": "ScalarField",
            "name": "canEditMembers"
          },
          {
            "concreteType": "ContributorConnection",
            "kind": "LinkedField",
            "name": "contributors",
            "plural": false,
            "selections": [
              {
                "concreteType": "ContributorEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v30/*: any*/),
                        "type": "User"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "teamId"
                          },
                          (v16/*: any*/),
                          {
                            "concreteType": "TeamDetails",
                            "kind": "LinkedField",
                            "name": "teamDetails",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "isVerified"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "state"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "membershipSettings"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "avatarUrl"
                          },
                          (v26/*: any*/),
                          {
                            "args": [
                              (v13/*: any*/)
                            ],
                            "kind": "ScalarField",
                            "name": "permission"
                          },
                          {
                            "args": [
                              (v6/*: any*/)
                            ],
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "membersOfProject",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "UserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v30/*: any*/)
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          }
                        ],
                        "type": "Team"
                      },
                      (v33/*: any*/)
                    ]
                  }
                ]
              },
              (v31/*: any*/)
            ]
          },
          {
            "concreteType": "GoalConnection",
            "kind": "LinkedField",
            "name": "goals",
            "plural": false,
            "selections": [
              {
                "concreteType": "GoalEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Goal",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v8/*: any*/),
                      {
                        "concreteType": "GoalIcon",
                        "kind": "LinkedField",
                        "name": "icon",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "appearance"
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalProgress",
                        "kind": "LinkedField",
                        "name": "progress",
                        "plural": false,
                        "selections": [
                          (v34/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "percentage"
                          }
                        ]
                      },
                      {
                        "concreteType": "MetricTargetConnection",
                        "kind": "LinkedField",
                        "name": "metricTargets",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "MetricTargetEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "MetricTarget",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "MetricValue",
                                    "kind": "LinkedField",
                                    "name": "snapshotValue",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v15/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "startValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "targetValue"
                                  },
                                  {
                                    "concreteType": "Metric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v34/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "subType"
                                      },
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v27/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "source"
                                      },
                                      {
                                        "concreteType": "MetricValue",
                                        "kind": "LinkedField",
                                        "name": "latestValue",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "time"
                                          },
                                          (v15/*: any*/)
                                        ]
                                      }
                                    ]
                                  },
                                  (v15/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "GoalConnection",
                        "kind": "LinkedField",
                        "name": "subGoals",
                        "plural": false,
                        "selections": (v35/*: any*/)
                      },
                      (v16/*: any*/),
                      (v22/*: any*/)
                    ]
                  }
                ]
              },
              (v36/*: any*/)
            ]
          },
          {
            "concreteType": "ProjectDependencyConnection",
            "kind": "LinkedField",
            "name": "dependencies",
            "plural": false,
            "selections": [
              {
                "concreteType": "ProjectDependencyEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "ProjectDependency",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "linkType"
                      },
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "outgoingProject",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v25/*: any*/),
                          (v11/*: any*/),
                          {
                            "concreteType": "IconURIs",
                            "kind": "LinkedField",
                            "name": "iconUrl",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "ThemeURIs",
                                "kind": "LinkedField",
                                "name": "square",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "light"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "dark"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "transparent"
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "concreteType": "ProjectState",
                            "kind": "LinkedField",
                            "name": "state",
                            "plural": false,
                            "selections": [
                              (v37/*: any*/),
                              (v38/*: any*/),
                              (v23/*: any*/),
                              {
                                "concreteType": "CompletionProjectState",
                                "kind": "LinkedField",
                                "name": "atCompletionState",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v37/*: any*/),
                                  (v38/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "alias": "dependencyId",
                        "kind": "ScalarField",
                        "name": "id"
                      },
                      {
                        "concreteType": "Project",
                        "kind": "LinkedField",
                        "name": "incomingProject",
                        "plural": false,
                        "selections": (v32/*: any*/)
                      },
                      (v15/*: any*/)
                    ]
                  }
                ]
              },
              (v36/*: any*/)
            ]
          },
          {
            "alias": "relatedLinks",
            "args": [
              {
                "kind": "Literal",
                "name": "type",
                "value": "RELATED"
              }
            ],
            "concreteType": "LinkConnection",
            "kind": "LinkedField",
            "name": "links",
            "plural": false,
            "selections": [
              {
                "concreteType": "LinkEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Link",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v39/*: any*/)
                    ]
                  }
                ]
              },
              (v36/*: any*/)
            ],
            "storageKey": "links(type:\"RELATED\")"
          },
          {
            "alias": "milestoneCount",
            "concreteType": "MilestoneConnection",
            "kind": "LinkedField",
            "name": "milestones",
            "plural": false,
            "selections": (v35/*: any*/)
          },
          {
            "concreteType": "TagConnection",
            "kind": "LinkedField",
            "name": "tags",
            "plural": false,
            "selections": [
              {
                "concreteType": "TagEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "Tag",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v25/*: any*/),
                      (v16/*: any*/),
                      (v40/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "projectUsageCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "goalUsageCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "helpPointerUsageCount"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "watcherCount"
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": "tagConnectionId",
                    "kind": "ScalarField",
                    "name": "__id"
                  }
                ]
              }
            ]
          },
          {
            "concreteType": "CustomFieldConnection",
            "kind": "LinkedField",
            "name": "customFields",
            "plural": false,
            "selections": [
              {
                "concreteType": "CustomFieldEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v28/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          (v41/*: any*/),
                          {
                            "concreteType": "CustomFieldTextSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "alias": "textValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v47/*: any*/)
                        ],
                        "type": "TextCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          (v41/*: any*/),
                          {
                            "concreteType": "CustomFieldNumberSavedValueNode",
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "alias": "numberValue",
                                "kind": "ScalarField",
                                "name": "value"
                              }
                            ]
                          },
                          (v47/*: any*/)
                        ],
                        "type": "NumberCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v16/*: any*/),
                                  (v40/*: any*/),
                                  (v43/*: any*/)
                                ],
                                "type": "UserCustomFieldDefinition"
                              },
                              (v33/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "UserConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "UserEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "User",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v9/*: any*/),
                                      (v29/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  (v46/*: any*/)
                                ]
                              }
                            ],
                            "type": "CustomFieldNode",
                            "abstractKey": "__isCustomFieldNode"
                          }
                        ],
                        "type": "UserCustomField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "definition",
                            "plural": false,
                            "selections": [
                              (v28/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v16/*: any*/),
                                  (v40/*: any*/),
                                  (v43/*: any*/),
                                  {
                                    "concreteType": "CustomFieldTextAllowedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "allowedValues",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "CustomFieldTextAllowedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "CustomFieldTextAllowedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v48/*: any*/)
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ],
                                "type": "TextSelectCustomFieldDefinition"
                              },
                              (v33/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "CustomFieldTextSavedValueConnection",
                            "kind": "LinkedField",
                            "name": "values",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "CustomFieldTextSavedValueEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "CustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v48/*: any*/)
                                  }
                                ]
                              },
                              (v31/*: any*/)
                            ]
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "definition",
                                "plural": false,
                                "selections": [
                                  (v42/*: any*/),
                                  (v45/*: any*/)
                                ]
                              }
                            ],
                            "type": "CustomFieldNode",
                            "abstractKey": "__isCustomFieldNode"
                          }
                        ],
                        "type": "TextSelectCustomField"
                      },
                      (v33/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "targetDateSet"
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "workTrackingLinks",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "WORK_TRACKING"
                  }
                ],
                "concreteType": "LinkConnection",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "LinkEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Link",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v39/*: any*/),
                          (v16/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v36/*: any*/)
                ],
                "storageKey": "links(first:1,type:\"WORK_TRACKING\")"
              },
              {
                "concreteType": "FusionDetails",
                "kind": "LinkedField",
                "name": "fusion",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "synced"
                  }
                ]
              },
              {
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "Site",
                    "kind": "LinkedField",
                    "name": "site",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ProductActivationConnection",
                        "kind": "LinkedField",
                        "name": "productActivations",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ProductActivationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "atlasForJiraCloudEnabled"
                                      }
                                    ],
                                    "type": "JiraProductActivation"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "areMilestonesEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v49/*: any*/),
                "concreteType": "MilestoneConnection",
                "kind": "LinkedField",
                "name": "milestones",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "MilestoneEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "Milestone",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "title"
                          },
                          (v24/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "targetDateType"
                          },
                          (v50/*: any*/),
                          (v28/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  },
                  (v50/*: any*/)
                ],
                "storageKey": "milestones(first:20)"
              },
              {
                "args": (v49/*: any*/),
                "handle": "connection",
                "key": "Project__milestones",
                "kind": "LinkedHandle",
                "name": "milestones"
              },
              {
                "concreteType": "TownsquareProjectCapabilities",
                "kind": "LinkedField",
                "name": "capabilities",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "canAddMilestones"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canEditMilestones"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "canRemoveMilestones"
                  }
                ]
              }
            ]
          },
          {
            "condition": "isProjectNativeIntegrationEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "Workspace",
                "kind": "LinkedField",
                "name": "workspace",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "cloudUrl"
                  },
                  {
                    "concreteType": "Site",
                    "kind": "LinkedField",
                    "name": "site",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "ProductActivationConnection",
                        "kind": "LinkedField",
                        "name": "productActivations",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "ProductActivationEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v28/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v15/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v14/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": (v20/*: any*/)
      }
    ]
  },
  "params": {
    "cacheID": "5bd728e7692917e858a76b43b4341cdd",
    "id": null,
    "metadata": {},
    "name": "ProjectViewAsideQuery",
    "operationKind": "query",
    "text": "query ProjectViewAsideQuery(\n  $key: String!\n  $trackViewEvent: TrackViewEvent\n  $workspaceId: ID\n  $areMilestonesEnabled: Boolean!\n  $cloudId: String\n  $isProjectNativeIntegrationEnabled: Boolean!\n) {\n  project: projectByKey(key: $key, trackViewEvent: $trackViewEvent) {\n    ari\n    owner {\n      aaid\n      id\n    }\n    private\n    members {\n      ...utils_isUserInList\n    }\n    watchers {\n      ...utils_isUserInList\n    }\n    ...ProjectSidebar_1WFJVC\n    id\n  }\n  currentUser(workspaceId: $workspaceId) {\n    aaid\n    id\n  }\n}\n\nfragment AddOrEditButton on CustomFieldNode {\n  __isCustomFieldNode: __typename\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      type\n    }\n    ... on UserCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on TextSelectCustomFieldDefinition {\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection on UserConnection {\n  count\n  edges {\n    node {\n      pii {\n        name\n        picture\n        accountId\n      }\n      id\n    }\n  }\n}\n\nfragment FollowersSidebarSection_Owner on UserPII {\n  accountId\n}\n\nfragment FollowersSidebarSection_ProjectKey on Project {\n  key\n}\n\nfragment FreeformNumberField on NumberCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    numberValue: value\n  }\n}\n\nfragment FreeformTextField on TextCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on CustomFieldDefinitionNode {\n      __isCustomFieldDefinitionNode: __typename\n      name\n      description\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  value {\n    id\n    textValue: value\n  }\n}\n\nfragment GenericWorkTrackingLinks on Project {\n  id\n  workTrackingLinks: links(type: WORK_TRACKING, first: 1) {\n    ...ProjectLinks\n  }\n}\n\nfragment GoalItem on Goal {\n  ...PlatformGoalIcon\n  ...progressBarMetricTarget\n  ...MetricChart\n  progress {\n    percentage\n  }\n  name\n  key\n  id\n}\n\nfragment InviteUserPromptPopup on Project {\n  watchers {\n    count\n  }\n}\n\nfragment JiraWork on Project {\n  ari\n}\n\nfragment LinkedGoals on Project {\n  id\n  ari\n  uuid\n  goals {\n    edges {\n      node {\n        id\n        ari\n        ...GoalItem\n      }\n    }\n  }\n}\n\nfragment LinkedProject on ProjectDependency {\n  dependencyId: id\n  incomingProject {\n    id\n  }\n  outgoingProject {\n    id\n    ...ProjectName_data\n    state {\n      ...ProjectState\n    }\n  }\n}\n\nfragment LinkedProjects on Project {\n  id\n  key\n  dependencies {\n    edges {\n      node {\n        linkType\n        outgoingProject {\n          key\n          id\n        }\n        ...LinkedProject\n        id\n      }\n    }\n  }\n}\n\nfragment MetaActions on Project {\n  key\n  private\n  ...ProjectStateAndTargetDate\n  ...ProjectFollowButton\n  ...InviteUserPromptPopup\n  ...ProjectActions\n}\n\nfragment MetricChart on Goal {\n  ...WrappedWithMetricPopup\n  id\n  progress {\n    type\n    percentage\n  }\n  subGoals {\n    count\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          source\n          latestValue {\n            time\n            id\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment MilestoneFields on Milestone {\n  id\n  title\n  targetDate\n  targetDateType\n  status\n}\n\nfragment Milestones on Project {\n  creationDate\n  startDate\n  milestones(first: 20) {\n    edges {\n      node {\n        id\n        status\n        ...MilestoneFields\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  capabilities {\n    canAddMilestones\n    canEditMilestones\n    canRemoveMilestones\n  }\n}\n\nfragment PlatformGoalIcon on Goal {\n  icon {\n    key\n    appearance\n  }\n}\n\nfragment ProjectActions on Project {\n  id\n  ari\n  name\n  archived\n  private\n  capabilities {\n    canArchiveProject\n  }\n}\n\nfragment ProjectContributors_OtPnR on Project {\n  id\n  name\n  key\n  canEditMembers\n  private\n  owner {\n    aaid\n    id\n  }\n  contributors {\n    edges {\n      node {\n        __typename\n        ... on User {\n          aaid\n          ...UserItem\n        }\n        ... on Team {\n          id\n          teamId\n          name\n          ...TeamAndMembersItem_OtPnR\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n    }\n  }\n  members {\n    count\n    edges {\n      node {\n        aaid\n        id\n      }\n    }\n  }\n}\n\nfragment ProjectFocusAreas_sidebar on Project {\n  ari\n}\n\nfragment ProjectFollowButton on Project {\n  id\n  ari\n  uuid\n  watching\n  capabilities {\n    canWatchProject\n  }\n}\n\nfragment ProjectIcon on Project {\n  private\n  iconUrl {\n    square {\n      light\n      dark\n      transparent\n    }\n  }\n}\n\nfragment ProjectLinkedGoals_sidebar on Project {\n  ...LinkedGoals\n}\n\nfragment ProjectLinks on LinkConnection {\n  edges {\n    node {\n      id\n      name\n      url\n    }\n  }\n}\n\nfragment ProjectName_data on Project {\n  id\n  key\n  name\n  uuid\n  ...ProjectIcon\n}\n\nfragment ProjectOwner on Project {\n  id\n  ari\n  key\n  canEditMembers\n  owner {\n    aaid\n    pii {\n      name\n      picture\n      accountStatus\n      email\n    }\n    ...UserAvatar\n    id\n  }\n}\n\nfragment ProjectSidebar_1WFJVC on Project {\n  id\n  key\n  ...MetaActions\n  ...ProjectOwner\n  ...ProjectContributors_OtPnR\n  ...ProjectLinkedGoals_sidebar\n  ...LinkedProjects\n  ...WorkTrackingLinks @skip(if: $isProjectNativeIntegrationEnabled)\n  ...RelatedLinks\n  ...Milestones @include(if: $areMilestonesEnabled)\n  ...FollowersSidebarSection_ProjectKey\n  ...JiraWork @include(if: $isProjectNativeIntegrationEnabled)\n  workspace @include(if: $isProjectNativeIntegrationEnabled) {\n    cloudUrl\n    site {\n      productActivations {\n        edges {\n          node {\n            __typename\n          }\n        }\n      }\n    }\n    id\n  }\n  ...ProjectFocusAreas_sidebar\n  milestoneCount: milestones {\n    count\n  }\n  ...ProjectTags_sidebar\n  customFields {\n    ...SidebarFields\n  }\n  watchers {\n    ...FollowersSidebarSection\n  }\n  owner {\n    pii {\n      ...FollowersSidebarSection_Owner\n    }\n    id\n  }\n  ...ProjectStartDate\n}\n\nfragment ProjectStartDate on Project {\n  id\n  startDate\n  ...ProjectStartDatePicker\n}\n\nfragment ProjectStartDatePicker on Project {\n  startDate\n  targetDate\n  targetDateSet\n  creationDate\n  state {\n    value\n  }\n}\n\nfragment ProjectState on ProjectState {\n  label\n  localizedLabel {\n    messageId\n  }\n  value\n  atCompletionState {\n    value\n    label\n    localizedLabel {\n      messageId\n    }\n  }\n}\n\nfragment ProjectStateAndTargetDate on Project {\n  state {\n    value\n    atCompletionState {\n      value\n    }\n  }\n  creationDate\n  startDate\n  targetDate\n  targetDateConfidence\n}\n\nfragment ProjectTags_sidebar on Project {\n  id\n  tags {\n    ...Tags\n  }\n}\n\nfragment RelatedLinks on Project {\n  id\n  relatedLinks: links(type: RELATED) {\n    ...ProjectLinks\n  }\n}\n\nfragment RemoveMemberButton on User {\n  id\n  aaid\n  pii {\n    name\n  }\n}\n\nfragment SelectField on TextSelectCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on TextSelectCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n      allowedValues {\n        edges {\n          node {\n            id\n            value\n          }\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        value\n      }\n    }\n  }\n}\n\nfragment SidebarFields on CustomFieldConnection {\n  edges {\n    node {\n      __typename\n      ... on TextCustomField {\n        ...FreeformTextField\n      }\n      ... on NumberCustomField {\n        ...FreeformNumberField\n      }\n      ... on UserCustomField {\n        ...UserField\n      }\n      ... on TextSelectCustomField {\n        ...SelectField\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment Tag on Tag {\n  ...Tag_createTagOption\n}\n\nfragment Tag_createTagOption on Tag {\n  id\n  name\n  uuid\n  description\n  projectUsageCount\n  goalUsageCount\n  helpPointerUsageCount\n  watcherCount\n}\n\nfragment Tags on TagConnection {\n  edges {\n    node {\n      id\n      uuid\n      name\n      ...Tag\n      ...Tag_createTagOption\n    }\n  }\n}\n\nfragment TeamAndMembersItem_OtPnR on Team {\n  ...TeamItem_PVNZy\n  name\n  id\n  teamId\n  teamDetails {\n    membershipSettings\n  }\n  permission(cloudId: $cloudId)\n  membersOfProject(key: $key) {\n    edges {\n      node {\n        aaid\n        ...UserItem\n        id\n      }\n    }\n  }\n}\n\nfragment TeamAvatar on Team {\n  id\n  name\n  teamId\n  teamDetails {\n    isVerified\n  }\n  avatarUrl\n}\n\nfragment TeamItem_PVNZy on Team {\n  id\n  name\n  teamId\n  ...TeamAvatar\n  ...TeamOptionsMenu_PVNZy\n}\n\nfragment TeamOptionsMenu_PVNZy on Team {\n  id\n  teamId\n  name\n  watching\n  permission(cloudId: $cloudId)\n  teamDetails {\n    state\n  }\n}\n\nfragment UserAvatar on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n  }\n}\n\nfragment UserAvatar_1TWJ92 on User {\n  aaid\n  pii {\n    picture\n    name\n    accountStatus\n    accountId\n    extendedProfile {\n      jobTitle\n    }\n  }\n}\n\nfragment UserField on UserCustomField {\n  ...AddOrEditButton\n  id\n  definition {\n    __typename\n    ... on UserCustomFieldDefinition {\n      name\n      description\n      canSetMultipleValues\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  values {\n    edges {\n      node {\n        id\n        aaid\n        ...UserAvatar_1TWJ92\n      }\n    }\n  }\n}\n\nfragment UserItem on User {\n  ...UserAvatar_1TWJ92\n  ...RemoveMemberButton\n}\n\nfragment WorkTrackingLinks on Project {\n  id\n  uuid\n  key\n  ari\n  workTrackingLinks: links(type: WORK_TRACKING, first: 1) {\n    edges {\n      node {\n        id\n        url\n      }\n    }\n  }\n  fusion {\n    synced\n  }\n  workspace {\n    site {\n      productActivations {\n        edges {\n          node {\n            __typename\n            ... on JiraProductActivation {\n              atlasForJiraCloudEnabled\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n  ...GenericWorkTrackingLinks\n}\n\nfragment WrappedWithMetricPopup on Goal {\n  id\n  progress {\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        ...common_metricTarget_direct\n        metric {\n          archived\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment common_metricTarget_direct on MetricTarget {\n  startValue\n  targetValue\n  snapshotValue {\n    value\n    id\n  }\n  metric {\n    id\n    name\n    type\n    subType\n  }\n}\n\nfragment progressBarMetricTarget on Goal {\n  progress {\n    type\n    percentage\n  }\n  metricTargets {\n    edges {\n      node {\n        snapshotValue {\n          value\n          id\n        }\n        startValue\n        targetValue\n        metric {\n          type\n          subType\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment utils_isUserInList on UserConnection {\n  edges {\n    node {\n      aaid\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f3beb53fd81d24d6d4fa7ae3ea981078";

export default node;
